'use client'

import { SERVER_BASE_URL } from '@telesoft/lib/web/constants'
import Grid from '../components/grid'
import Container from '../components/ui/container'
import Text from '../components/ui/text'
import { Asset } from '../v2/components/Asset'
import { fields } from '../v2/components/CMSForm/fields'
import { Button } from '../v2/components/ui/button'
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '../v2/components/ui/form'
import { useFormHook } from '@telesoft/lib/web/use-form-submission'
import { Asset as AssetType, Form as FormType, Page } from '@telesoft/types/payload-types'
import React from 'react'

export type BlockProps = Extract<Page['blocks'][0], { blockType: 'subscribe-to-nucleus-cta' }>

export default function SubscribeToNucleusCTA(block: BlockProps) {
  const {
    title = 'Subscribe to Nucleus updates.',
    description = 'Subscribe to our newsletter and stay updated.',
  } = block

  const cmsForm = block?.form as FormType

  const { form, error, isLoading, hasSubmitted, onSubmit } = useFormHook(cmsForm)

  return (
    <Container>
      <Grid className="bg-heading relative overflow-hidden p-8 md:p-12 lg:p-20">
        <div className="z-10 col-span-full self-center md:col-span-4">
          <Text variant="subHeading" className="text-white">
            {title}
          </Text>
        </div>

        <div className="z-10 col-span-full self-end text-white md:col-span-4">
          <Text variant="body" className="text-white text-opacity-70">
            {description}
          </Text>
        </div>
        {hasSubmitted && (
          <div className="bg-telesoft z-10 col-span-4 p-4 text-black">
            Thank you for subscribing to Nucleus.
          </div>
        )}
        {isLoading && !hasSubmitted && <p>Loading, please wait...</p>}
        {error && <div>{`${error.status || '500'}: ${error.message || ''}`}</div>}

        {!hasSubmitted && (
          <Form {...form}>
            <form
              className="z-20 col-span-full flex flex-col items-stretch space-y-4 md:col-span-4 xl:flex-row xl:items-end xl:justify-end xl:space-x-4"
              onSubmit={form.handleSubmit(data => onSubmit({ data }))}
            >
              {cmsForm.fields?.map(fieldItem => {
                const Field: React.FC<any> = fields?.[fieldItem.blockType]
                const label = 'label' in fieldItem ? fieldItem.label : null
                return (
                  <FormField
                    key={fieldItem.id}
                    control={form.control}
                    // @ts-ignore
                    name={'name' in fieldItem ? fieldItem.name! : fieldItem.id}
                    render={({ field }) => (
                      <FormItem className="w-full">
                        {label && <FormLabel className="text-white/50">{label}</FormLabel>}
                        <FormControl>
                          <Field
                            placeholder="Enter your email"
                            className="border-b-white text-white"
                            {...field}
                          />
                        </FormControl>
                        <FormMessage />
                      </FormItem>
                    )}
                  />
                )
              })}
              <FormItem>
                <Button size={'sm'} variant={'default'} type="submit" className="text-white">
                  {cmsForm?.submitButtonLabel || 'Submit'}
                </Button>
              </FormItem>
            </form>
          </Form>
        )}
        <Asset
          resource={block.image as AssetType}
          fill
          imgClassName="object-cover object-center opacity-20 z-0"
        />
      </Grid>
    </Container>
  )
}

export const defaultBlockJSON: BlockProps = {
  title: 'Subscribe to Nucleus blog updates',
  description: 'Subscribe to our newsletter and stay updated.',
  form: {
    id: '65d7530596609323282bda95',
    title: '[ LEADS ] Newsletter',
    fields: [
      {
        name: 'email',
        label: 'Business Email',
        width: 100,
        required: true,
        id: '65d7530532a1a77dbadd2a35',
        blockType: 'email',
      },
    ],
    confirmationType: 'message',
    confirmationMessage: [{ children: [{ text: "You've been subscribed, thank you." }] }],
    emails: [],
    isUploadField: false,
    createdAt: '2024-02-22T13:58:29.891Z',
    updatedAt: '2024-02-22T14:11:50.524Z',
  },
  image: {
    id: '64fa00a13dfcc95505bb047b',
    alt: 'telesoft-sales-7',
    filename: 'telesoft-sales-7.webp',
    mimeType: 'image/webp',
    filesize: 166176,
    width: 1440,
    height: 960,
    createdAt: '2023-09-07T16:56:01.752Z',
    updatedAt: '2023-09-07T16:56:01.752Z',
    url: `${SERVER_BASE_URL}/assets/telesoft-sales-7.webp`,
  },
  id: '65d7574832a1a77dbadd2a36',
  blockType: 'subscribe-to-nucleus-cta',
}
